import React, { useState } from 'react'
import callApi from '../../helpers/callapi'
import moment from 'moment'
import { Button, Modal } from 'react-bootstrap'
import Eye from './eye'
import styled from 'styled-components'
import { useDispatch } from 'react-redux'

const OpenPass = styled.span`
  cursor: pointer;
`

moment.locale('th')
export default function AddModal({ setIsVisible, onClose, isVisible }) {
  const [openPassword, setOpenPassword] = useState(false)
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')

  const dispatch = useDispatch()

  const createAdmin = async () => {
    try {
      //   setLoading(true);
      dispatch({ type: 'loading_show' })
      await callApi({
        url: `/admins`,
        method: 'post',
        body: { username: username, password: password },
      })
      //   setLoading(false);
      dispatch({ type: 'loading_hide' })
      setIsVisible(false)
      onClose()
      // fetchOrders(currentPage);
    } catch (error) {
      console.error('Error while trying to fetch orders.', error)
      //   message.error(get(error, 'reason.message'));
      //   setLoading(false);
      dispatch({ type: 'loading_hide' })
    }
  }

  return (
    <Modal className="fade bd-example-modal-lg" show={isVisible} size="lg">
      <Modal.Header>
        <Modal.Title>เพิ่มผู้ดูแลระบบ</Modal.Title>
        <Button variant="" className="close" onClick={() => setIsVisible(false)}>
          <span>&times;</span>
        </Button>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={(e) => e.preventDefault()}>
          <div className="form-group row">
            <label className="col-sm-3 col-form-label">Username: </label>
            <div className="col-sm-9">
              <input
                type="username"
                className="form-control"
                placeholder="Username"
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>
          </div>
          <div className="form-group row">
            <label className="col-sm-3 col-form-label">Password: </label>
            <div className="col-sm-9">
              <div className="input-group mb-3 ">
                <input
                  type={openPassword ? 'text' : 'Password'}
                  className="form-control"
                  placeholder="Password"
                  onChange={(e) => setPassword(e.target.value)}
                />
                <div className="input-group-append">
                  <OpenPass className="input-group-text" onClick={() => setOpenPassword(!openPassword)}>
                    <Eye type={openPassword} />
                  </OpenPass>
                </div>
              </div>
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger light" onClick={() => setIsVisible(false)}>
          ยกเลิก
        </Button>
        <Button variant="" type="primary" key="submit" className="btn btn-primary" onClick={() => createAdmin()}>
          สร้างผู้ดูแลระบบ
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
